import { apiErrorMessage } from './ApiError';
import { axiosApi } from './axios.api';
import { SupplierDataArray, SupplierModel, SupplierQueryParams } from '@app/interfaces/supplier';

const url = `/api/suppliers`;

export const getSuppliersApi = async (params: SupplierQueryParams): Promise<SupplierDataArray | undefined> => {
  try {
    const suppliersApi = url;
    const response = await axiosApi.get<SupplierDataArray>(suppliersApi, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getSupplierApi = async (supplierId: number) => {
  try {
    const response = await axiosApi.get(`${url}/${supplierId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createSupplierApi = async (data: SupplierModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateSupplierApi = async (supplierId: number, formData: SupplierModel) => {
  try {
    const response = await axiosApi.put(`${url}/${supplierId}`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteSupplierApi = async (supplierId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${supplierId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportSupplierApi = async (params?: Record<string, unknown>) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `supliers.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export interface SupplierTopItem {
  name: string;
  value: number;
}

export interface SupplierStatsData {
  summary: {
    total_suppliers: number;
    total_purchase_qty: number;
    total_purchase_amount: number;
    total_debit: number;
    suppliers_with_debit: number;
  };
  top_by_qty: SupplierTopItem[];
  top_by_amount: SupplierTopItem[];
  top_by_debit: SupplierTopItem[];
}

export const getSupplierStatsApi = async (
  params?: { from_date: string; to_date: string },
): Promise<SupplierStatsData | undefined> => {
  try {
    const response = await axiosApi.get<SupplierStatsData>(`${url}/stats`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};


export interface SupplierTypeItem {
  id: number;
  name: string;
}

/** Nhóm NCC — dùng cho options của bộ lọc nâng cao. */
export const getSupplierTypesApi = async (): Promise<SupplierTypeItem[]> => {
  try {
    const response = await axiosApi.get<any>('/api/supplier/types');
    const rows = response.data?.rows ?? response.data ?? [];
    return rows.map((row: any) => {
      const attributes = row?.attributes ?? row;
      return { id: Number(attributes.id ?? row.id), name: attributes.name };
    });
  } catch (error: any) {
    apiErrorMessage(error);
    return [];
  }
};

interface SupplierDetailExportParams {
  from_date?: string;
  to_date?: string;
  type?: string;
}

/** Tải file Excel trả về từ backend và kích hoạt download. */
const downloadExport = async (path: string, fileName: string, params?: SupplierDetailExportParams) => {
  const response = await axiosApi.get(path, { params, responseType: 'blob' });

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

/** Xuất tab "Lịch sử nhập/trả hàng" của một NCC. */
export const exportSupplierMovementsApi = async (
  supplierId: number,
  params?: SupplierDetailExportParams,
) => {
  try {
    await downloadExport(`${url}/${supplierId}/export_movements`, 'supplier_movements.xlsx', params);
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};

/** Xuất tab "Công nợ nhà cung cấp" của một NCC. */
export const exportSupplierTransactionsApi = async (
  supplierId: number,
  params?: SupplierDetailExportParams,
) => {
  try {
    await downloadExport(`${url}/${supplierId}/export_transactions`, 'supplier_transactions.xlsx', params);
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};
